import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AssetDetailPageDisplay from '../asset_detail_page_display/AssetDetailPageDisplay';
import { FC } from 'react';
import { getEntityById, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import OWResult from '../OWResult';

require('./AssetsDetailDetailsPage.less');

const AssetsDetailsDetailPage: FC<any> = ({
	asset,
	assetsFetching,
	assetsError,
}): React.ReactElement => {
	const assetAccessError = nullSafeGetOrElse('length', assetsError, 0) > 0;
	const fetching = !asset.id && assetsFetching;
	return fetching ? (
		<PageLoadingPlaceholder />
	) : assetAccessError ? (
		<OWResult
			error={'Do not have permission to perform this action'}
			title="You do not have access to this asset"
		/>
	) : (
		<AssetDetailPageDisplay key={asset.id} asset={asset} />
	);
};

const mapStateToProps = (state, ownProps) => ({
	assetsError: state.assets.fetchErrors,
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	match: ownProps.match,
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(AssetsDetailsDetailPage)
);
